/**
 * Leadership Live URL for a published resource.
 *
 * Xceed does not host the CMS player (SCORM, xAPI, many templates). Open
 * always goes to ll-site: `/resource/:activity/:slug`.
 */
export function leadershipLiveResourceUrl(
  origin: string,
  resource: { activity: string; slug: string }
): string | null {
  if (!origin || !resource.activity || !resource.slug) {
    return null;
  }

  const base = origin.replace(/\/$/, '');
  return `${base}/resource/${encodeURIComponent(resource.activity)}/${encodeURIComponent(resource.slug)}`;
}
